import { UserManagerSettings } from 'oidc-client-ts';

export const OIDC_CALLBACK_PATH = '/oauth/oidc-callback';
export const SILENT_CALLBACK_PATH = '/oauth/silent-callback';
export const OIDC_REGISTER_PATH = '/oauth/register';
export const ACCOUNT_AUTH_MODULAR_SIGNUP_PATH_RE =
  /^\/account\/auth\/([^/]+)\/modular\/([^/]+)\/signup$/;
const AUTHORITY = `${process.env.REACT_APP_OIDC_AUTHORITY as string}realms/Skema`;
export const KEYCLOAK_ACCOUNT_URL = `${AUTHORITY}/account`;

const OIDC_CLIENT_ID =
  (process.env.REACT_APP_OIDC_CLIENT_ID as string | undefined)?.trim();


export const oidcConfig: UserManagerSettings = {
  authority: AUTHORITY,
  client_id: OIDC_CLIENT_ID ?? 'skema-app',
  redirect_uri: location.origin + OIDC_CALLBACK_PATH,
  silent_redirect_uri: location.origin + SILENT_CALLBACK_PATH,
  scope: (process.env.REACT_APP_OIDC_SCOPE as string | undefined) ?? 'openid profile email',
  response_type: 'code',
  post_logout_redirect_uri: window.location.origin,
  automaticSilentRenew: true,
  silentRequestTimeoutInSeconds: 2,
  monitorSession: true,
};

